import { HttpRequestData, httpUtil } from '@esg/framework';
import { getEnv, GoogleRatingStatus } from '@esg/shared';

interface CheckReviewRequest extends HttpRequestData {
    readonly pathData: {
        readonly reviewToken?: string;
    };
    readonly query: {
        readonly saleId?: string;
    },
}

export interface CheckReviewResponse {
    readonly id?: string;
    readonly rating?: number;
    readonly feedback?: string;
    readonly customerId?: string;
    readonly googleRatingStatus?: GoogleRatingStatus;
    readonly saleId?: string;
    readonly branchId?: string;
}

export const checkReview = httpUtil.createHttpRequestMeta<
    CheckReviewRequest,
    CheckReviewResponse
>({
    baseUrl: () => getEnv().MANAGEMENT_SERVER,
    method: 'GET',
    path: '/api/v1/reviews/:reviewToken/check-review',
});
